module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAEACAYAAACzuVY0AAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAACTSURBVHja7NsxDgAhCABBIP7/y2hrT2HMmFy7gV3ay+6OybfOl5PAiuFnQhNaWRQrc2hlUTgUBdDZAAICAgICAgICXsDiENBhc6iyKCoDiiIKhxyKwiGHHHLIIYcccsghhxxyKAqHgKKIwqHKoqgMCOiwAQEBAQEBAQE/BPpfD9DZiMKhKFbm0MqiiGLC1ybcAgwA3BYHyjPpaSsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/colorpicker/bar-saturation.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/colorpicker/bar-saturation.png
// module chunks = styles